export var isApiGatewayUrl = function isApiGatewayUrl(url) {
  return ['/gateway/api'].includes(url);
};